import React, { ChangeEventHandler, FC, Fragment, useEffect, useState } from 'react'
import { IProduct } from '../../../types/IProduct'
import styles from './ProductSnippet.module.css'
import ProductAddToCart from '../../ProductAddToCart/ProductAddToCart'
import { getPrice } from '../../../libs/common'
import { useCart } from '../../../contexts/CartContext'
import Icon from '../../units/Icon'

interface IProductSnippetProps {
  product: IProduct
}

const ProductSnippet: FC<IProductSnippetProps> = (props) => {
  const { product } = props
  const [quantity, setQuantity] = useState<number | ''>(1)
  const cart = useCart()
  const cartProduct = cart.cartProducts.find((cartProduct) => cartProduct.data.id === product.id)

  useEffect(() => {
    if (cartProduct?.data.quantity) {
      setQuantity(cartProduct.data.quantity)
    }
  }, [cartProduct])

  const handleChangeQuantity: ChangeEventHandler<HTMLInputElement> = (event) => {
    const quantity = Number(event.target.value || '0')

    if (cartProduct) {
      cart.updateCartProduct(cartProduct.data.id, quantity)
    }

    setQuantity(quantity || '')
  }

  const handleChangeBlur: ChangeEventHandler<HTMLInputElement> = (event) => {
    const quantity = Number(event.target.value || '1')

    if (cartProduct) {
      cart.updateCartProduct(cartProduct.data.id, quantity)
    }

    setQuantity(quantity || '')
  }

  const [isZoomed, setIsZoomed] = useState(false)

  const handleZoomImage = () => {
    setIsZoomed(!isZoomed)
  }

  return (
    <div className={styles.product}>
      <div className={styles.top}>
        <div className={styles.header}>
          <span className={styles.title}>{product.name}</span>
        </div>
        {isZoomed ? (
          <Fragment>
            <div
              style={{
                backgroundColor: 'rgba(0,0,0,.6)',
                position: 'fixed',
                inset: 0,
                zIndex: 11,
              }}
              onClick={handleZoomImage}
            />
            <div className={styles.closeButton} onClick={handleZoomImage}>
              ⨯
            </div>
          </Fragment>
        ) : null}
        <img
          src={product.images[0].original}
          alt=""
          onClick={handleZoomImage}
          style={
            isZoomed
              ? {
                  top: '4%',
                  left: '8%',
                  position: 'fixed',
                  width: '84%',
                  height: '92vh',
                  maxHeight: 'none',
                  maxWidth: 'none',
                  objectFit: 'contain',
                  zIndex: 12,
                }
              : undefined
          }
        />
      </div>
      <div className={styles.bottom}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <button
            className={styles.quantityButton}
            onClick={() => {
              const newQuantity = Math.max((quantity || 1) - 1, 1)
              if (cartProduct) {
                cart.updateCartProduct(cartProduct.data.id, newQuantity)
              }
              setQuantity(newQuantity)
            }}
          >
            <Icon hash="minus" size={24} />
          </button>
          <input
            className={styles.quantityInput}
            min={1}
            type="tel"
            name="quantity"
            onChange={handleChangeQuantity}
            value={quantity || ''}
            onBlur={handleChangeBlur}
          />
          <button
            className={styles.quantityButton}
            onClick={() => {
              const newQuantity = Math.min((quantity || 1) + 1, 99)
              if (cartProduct) {
                cart.updateCartProduct(cartProduct.data.id, newQuantity)
              }
              setQuantity(newQuantity)
            }}
          >
            <Icon hash="plus" size={24} />
          </button>
          <span className={styles.cost}>{getPrice(product.cost * (quantity || 1))}</span>
        </div>
        <ProductAddToCart product={product} quantity={quantity || 1} />
      </div>
    </div>
  )
}

export default ProductSnippet
